export const priorityOptionConstants = [
  { name: "High", value: "high" },
  { name: "Medium", value: "medium" },
  { name: "Normal", value: "normal" },
  { name: "Low", value: "low" },
];
